<ng-container *ngIf="!collapsed()">
    <a class="side-nav__item" [ngClass]="itemClasses(item())" mat-list-item [routerLink]="item().path" routerLinkActive
        #rla="routerLinkActive" (click)="!item().children?.length && onLeafNavigate(item().path); toggleNestedMenu($event)">
        <div class="side-nav__icon" matListItemIcon>
            <img *ngIf="item().icon" [src]="item().icon" alt="icon">
        </div>
        <span matListItemTitle>{{item().label | translate}}</span>
        @if(item().children?.length){
        <span matListItemMeta>
            <img src="../../../../../assets/images/{{ !nestedMenuOpen() ? 'menuDown' : 'menuUp'}}.svg" alt="">
        </span>
        }
    </a>
    <ng-container *ngIf="item().children && nestedMenuOpen()">
        <div>
            @for (subItem of item().children; track subItem.label) {
            <lokos-menu-item [item]="subItem" [collapsed]="collapsed()" [level]="level() + 1" [menuPaths]="menuPaths()" />
            }
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="collapsed()">
    <ng-container *ngIf="!item().children;">
        <a class="side-nav__item" [ngClass]="itemClasses(item())" mat-list-item [routerLink]="item().path"
            routerLinkActive #rla="routerLinkActive" [activated]="rla.isActive"
            (click)="onLeafNavigate(item().path)">
            <div class="side-nav__icon" *ngIf="item().icon" matListItemIcon>
                <img *ngIf="item().icon" [src]="item().icon" alt="icon">
            </div>
        </a>
    </ng-container>
    <ng-container *ngIf="item().children;">
        <mat-list-item class="side-nav__item" (click)="trigger.toggleMenu()" [routerLink]="item().path" routerLinkActive
            #rla="routerLinkActive" [ngClass]="itemClasses(item())">
            <div class="side-nav__icon" *ngIf="item().icon" matListItemIcon>
                <img *ngIf="item().icon" [src]="item().icon" alt="icon">
            </div>
            <div [matMenuTriggerFor]="menu" #trigger="matMenuTrigger"></div>
        </mat-list-item>
        <mat-menu #menu="matMenu" class="side-nav__menu-panel">
            <ng-container *ngFor="let subItem of item().children;">
                <a mat-menu-item [disableRipple]="true" [routerLink]="subItem.path" routerLinkActive
                    #rla="routerLinkActive" [ngClass]="{ 'side-nav__menu-item--active': isActive(subItem) }"
                    (click)="onLeafNavigate(subItem.path)">
                    {{subItem.label | translate}}
                </a>
            </ng-container>
        </mat-menu>
    </ng-container>
</ng-container>
